export const SET_TITLE = 'header/SET_TITLE';

export function ChangeTitle(routes) {
    return dispatch => dispatch({
        type: SET_TITLE,
        payload: routes,
    });
}
